"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { normalizeIconSrc } from "@layerswap/wallet-core";
import LogoPlaceholder from "./LogoPlaceholder";
const toImageSrc = (src) => typeof src === "string" ? normalizeIconSrc(src) : src;
export const ImageWithFallback = forwardRef(({ src, ...props }, ref) => {
    const [imgSrc, setImgSrc] = useState(() => toImageSrc(src));
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        setImgSrc(toImageSrc(src));
        setHasError(false);
    }, [src]);
    const handleError = useCallback(() => {
        setHasError(true);
    }, [setHasError]);
    if (hasError) {
        return _jsx(LogoPlaceholder, { ...props });
    }
    return _jsx("img", { ...props, alt: props.alt || "ImageWithFallback", ref: ref, src: imgSrc, onError: handleError });
});
